// removed by extract-text-webpack-plugin
module.exports = {"divider":"divider--f1154"};